import styled from 'styled-components'

export const HeroWrapper = styled.div`
    position: relative;
`

export const Container = styled.div`
    max-width: 1170px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    position: relative;

    padding: 68px 15px 0;

    @media ${(props) => props.theme.query.min.tablet} {
        padding: 12vw 45px;
    }
`

export const ContentWrapper = styled.div`
    @media ${(props) => props.theme.query.mobile} {
        margin-top: 52px;
        margin-bottom: 100px;
    }
`
